import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type Props = {
  totalQty: number;
  cartId: string;
  linkToReviewPage: boolean;
};

export const CartTotalQty = ({ totalQty, cartId, linkToReviewPage }: Props) => {
  const { t } = useTranslation();

  return (
    <Link
      to={linkToReviewPage ? `/review/${cartId}` : `/get/${cartId}`}
      state={{ from: 'history' }}
      className='h-full w-full font-semibold text-primary hover:cursor-pointer hover:underline'
    >
      {t('common.item', { count: totalQty })}
    </Link>
  );
};
